import { render, staticRenderFns } from "./data_sort.vue?vue&type=template&id=0e3ed484&scoped=true"
import script from "./data_sort.vue?vue&type=script&lang=js"
export * from "./data_sort.vue?vue&type=script&lang=js"
import style0 from "./data_sort.vue?vue&type=style&index=0&id=0e3ed484&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3ed484",
  null
  
)

export default component.exports